import BaseModel from '@core/model';

import EventTypeEnum from '@constants/enums/event/type';
import NotificationAudienceEnum from '@constants/enums/notification/audience';
import NotificationGroupEnum from '@constants/enums/notification/group';
import NotificationTransportEnum from '@constants/enums/notification/transport';
import NotificationTypeEnum from '@constants/enums/notification/type';

import { Notification, Organisation } from '@/models';

export class NotificationPreference extends BaseModel {
    static name = 'NotificationPreference';
    static entity = 'notification-preferences';

    static runSetup = true;

    async setupLogic() {
        if (!this.event_type) {
            this.event_type = Notification.getEventTypeFromNotificationType(this.type);
        }
        if (!this.group) {
            this.group = Notification.getGroupFromNotificationType(this.type);
        }
        if (!this.$transport.length) {
            if (this.web !== null) {
                this.$transport.push(NotificationTransportEnum.WEB);
            }
            if (this.email !== null) {
                this.$transport.push(NotificationTransportEnum.EMAIL);
            }
        }
    }

    static fields() {
        return {
            ...super.fields(),
            //
            id: this.string(null).nullable(),
            type: this.enum(NotificationTypeEnum).nullable(),
            group: this.enum(NotificationGroupEnum).nullable(),
            event_type: this.enum(EventTypeEnum).nullable(),
            // Transport vehicles
            web: this.boolean(null).nullable(),
            email: this.boolean(null).nullable(),
            $transport: this.enumList(NotificationTransportEnum, []),
            //
            audience: this.enum(NotificationAudienceEnum).nullable(),
            organisation_id: this.string(null).nullable(),
            organisation: this.belongsTo(Organisation, 'organisation_id')
        };
    }

    static mock() {
        return {
            id: faker => faker.string.uuid(),
            type: faker => faker.helpers.arrayElement(Object.values(NotificationTypeEnum)),
            web: faker => faker.helpers.arrayElement([true, false]),
            email: faker => faker.helpers.arrayElement([null, true, false]),
            audience: faker => faker.helpers.arrayElement(Object.values(NotificationAudienceEnum))
        };
    }
}

export default NotificationPreference;
